const articles = import.meta.glob("/src/data/mdx/source/*.mdx", {
  eager: false,
});

export async function getArticleBySlug(slug) {
  console.log("🔍 Looking for slug:", slug);

  const normalizedSlug = decodeURIComponent(slug).toLowerCase();

  for (const path in articles) {
    const fileSlug = path.split("/").pop().replace(".mdx", "").toLowerCase();

    if (fileSlug === normalizedSlug) {
      console.log("✅ Match found:", path);

      try {
        const module = await articles[path]();

        // DEBUG: Log the entire module
        console.log("🔍 Full module:", module);
        console.log("🔍 Module keys:", Object.keys(module));
        console.log("🔍 Default export:", module.default);
        console.log("🔍 Default export type:", typeof module.default);

        if (!module.default) {
          throw new Error("MDX module missing default export");
        }

        const frontmatter = module.frontmatter || {};

        // Reading time and word count are now in frontmatter (auto-updated during build)
        const readingTime = frontmatter.readingTime || 1;
        const wordCount = frontmatter.wordCount || 0;

        console.log(
          `📊 Article stats - Words: ${wordCount}, Reading time: ${readingTime} mins`
        );

        return {
          frontmatter,
          Content: module.default,
          slug: fileSlug,
          path,
          readingTime,
          wordCount,
        };
      } catch (error) {
        console.error("❌ Error loading MDX module:", error);
        throw new Error(`Failed to load article: ${slug}`);
      }
    }
  }

  console.warn("❌ No match found for slug:", slug);
  return null;
}
